import { createFileRoute } from '@tanstack/react-router';

/**
 * No UI: the shell owns the drawer, which lets Radix keep it mounted through its slide-out. No
 * `beforeLoad` guard: only the fetched roster knows an id, and an unknown one leaves the sheet closed.
 */
export const Route = createFileRoute('/www/partner-ngos/$ngoId')({
	component: () => null,
});
